/**
 * Converts a string to a URL-safe slug.
 * "CRISPR Gene Editing" -> "crispr-gene-editing"
 */
export function slugify(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

/**
 * Generates a LOTSOG thread key from category info and date.
 * Examples:
 *   world_news + null + "2026-04-22"     -> "world_news__2026-04-22"
 *   specialty_1 + "crispr-gene-editing" + "2026-04-22"
 *                                        -> "specialty_1__crispr-gene-editing__2026-04-22"
 *   local_news + "indianapolis-in" + "2026-04-22"
 *                                        -> "local_news__indianapolis-in__2026-04-22"
 */
export function buildLotsogThreadKey(categoryId, topicSlug, briefingDate) {
  if (topicSlug) {
    return `${categoryId}__${topicSlug}__${briefingDate}`;
  }
  return `${categoryId}__${briefingDate}`;
}
